import revive_payload_client_4sVQNw7RlN from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/root/workspace/com.jufair.pc.nuxt3_46wE/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/root/workspace/com.jufair.pc.nuxt3_46wE/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "/root/workspace/com.jufair.pc.nuxt3_46wE/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/root/workspace/com.jufair.pc.nuxt3_46wE/.nuxt/element-plus-injection.plugin.mjs";
import globalMethods_qvaXUgTMQj from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/globalMethods.ts";
import v_counter_YpxjT5BpoW from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/v-counter.ts";
import directives_8CcCirWtnE from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/directives.ts";
import fundebug_6i0WvaxK8b from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/fundebug.ts";
import window_open_HzQ45Lfd2D from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/window-open.ts";
import baidu_map_client_ruqdbcpYpX from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/baidu-map.client.ts";
import svg_icon_HJoXDExWab from "/root/workspace/com.jufair.pc.nuxt3_46wE/plugins/svg-icon.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  globalMethods_qvaXUgTMQj,
  v_counter_YpxjT5BpoW,
  directives_8CcCirWtnE,
  fundebug_6i0WvaxK8b,
  window_open_HzQ45Lfd2D,
  baidu_map_client_ruqdbcpYpX,
  svg_icon_HJoXDExWab
]